import { useField } from "formik";
import { Key } from "react";

import { Select, SelectProps } from "./Select";
import {
  InputWrapper,
  InputWrapperProps,
} from "../../components/inputs/_assets/input-wrapper/InputWrapper";

interface Props<T> extends SelectProps<T>, Omit<InputWrapperProps, "children"> {
  name: string;
  label: string;
  info?: React.ReactNode;
  testID?: string;
  onChange?: (value: Key) => void;
}

/**
 * @deprecated use SelectFormikField instead - based on React Aria Components
 */
export function SelectInputField<T extends object>({
  name,
  span = "auto",
  testID = "select-input-field",
  onChange,
  ...props
}: Props<T>) {
  const [field, meta, helpers] = useField(name);

  return (
    <InputWrapper span={span}>
      <Select
        testID={testID}
        validationState={meta.touched && meta.error ? "invalid" : "valid"}
        errors={meta.touched && meta.error}
        {...field}
        {...props}
        selectedKey={field.value || null}
        onSelectionChange={(value) => {
          helpers.setValue(value);
          onChange?.(value);
        }}
      />
    </InputWrapper>
  );
}
